import { Component } from 'react'
import styled from '@emotion/styled'
import { withRouterProps } from '../../../../utils'

const QuickActionsWrapper = styled.div`
  align-items: center;
  cursor: pointer;
  padding: 0 0 0 40px;
  height: 44px;
  width: 100%;
  max-width: 100%;
  color: #4a606a;
  font-size: 26px;
  font-weight: 600;
  line-height: 27px;
`

class QuickActionMenu extends Component {
  render() {
    const { navigate } = this.props
    return (
      <QuickActionsWrapper
        onClick={() => {
          navigate('/quickactions')
        }}>
        Quick Actions
      </QuickActionsWrapper>
    )
  }
}
export default withRouterProps(QuickActionMenu)
